import api from './api';

class CustomerApi {
    static async updateUser(customerId, data) {
        return api
            .request({
                method: 'PUT',
                url: `/customers/${customerId}`,
                data
            })
            .then(res => res)
            .catch(console.error);
    }

    static async updateUserDefaultCard(customerId, cardId) {
        return api
            .request({
                method: 'PUT',
                url: `/customers/default-card/${customerId}`,
                data: cardId
            })
            .then(res => res)
            .catch(err => err);
    }

    static async createLead(data) {
        return api
            .request({
                method: 'POST',
                url: '/customers-lead?from=customer',
                data
            })
            .then(res => res)
            .catch(console.error);
    }
}

export default CustomerApi;
